import * as server from "@/utils/http"

export const _list = params => server.get("/develop-standard-management/list", params);


